import React from "react";
import { Grid2, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { Card } from "src/shared/ui";
import { products } from "src/widgets/ProductsGrid/model/constants";

export const ProductsGrid: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Grid2
      container
      spacing={3}
      sx={{
        "& > *": {
          minWidth: {
            md: "",
          },
        },
      }}
    >
      {products.map((product) => (
        <Grid2 key={product.icon} size={{ lg: 3, sm: 6, xs: 12 }}>
          <Card
            icon={product.icon}
            content={product.content}
            title={product.title}
            moreClick={() => navigate(product.path)}
            shareContent={product.path}
          />
        </Grid2>
      ))}
    </Grid2>
  );
};
